export default __webpack_public_path__ + "static/media/AllProductItems4.a420e4ed.png";